const cta = document.querySelector( '.main__wrap > .cta:last-child' );

if ( cta ) {
	cta.previousElementSibling.classList.add( 'has-cta-next' );
}
